import type { Dispatch, SetStateAction } from 'react';
import { useCallback } from 'react';
import { useUpdateSearchParams } from './useUpdateSearchParams';

type DateRangeFilterState = { startDate: string; endDate: string };

// Commit both endpoints together so neither local state nor the URL sees half a correction.
export function useDateRangeFilter<FiltersState extends DateRangeFilterState>(
    setFilters: Dispatch<SetStateAction<FiltersState>>
): (startDate: string, endDate: string) => void {
    const { updateSearchParamsBatch } = useUpdateSearchParams();

    return useCallback(
        (startDate, endDate) => {
            setFilters((previousFilters) => {
                if (
                    previousFilters.startDate === startDate &&
                    previousFilters.endDate === endDate
                ) {
                    return previousFilters;
                }

                return { ...previousFilters, startDate, endDate };
            });
            updateSearchParamsBatch({ startDate, endDate });
        },
        [setFilters, updateSearchParamsBatch]
    );
}
